export const GET_LESSON_REPORTS = 'lesson-reports/GET_REPORTS';
export const GET_LESSON_REPORTS_BY_STUDENT_ID =
  'lesson-reports/GET_REPORTS_BY_STUDENT_ID';
